import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { VstsBuildOutput } from '../../../models/vsts-models';

export interface PullRequestBuildData {
  title: string,
  groupedBuilds: any[]
}

@Component({
  selector: 'app-pull-request-builds',
  templateUrl: './pull-request-builds.component.html',
  styleUrls: ['./pull-request-builds.component.css']
})
export class PullRequestBuildsComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PullRequestBuildsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PullRequestBuildData) { }

  ngOnInit() {
  }

  onClose(): void {
    this.dialogRef.close();
  }

  shortStatus(build: VstsBuildOutput) {
    if (build.status === 'completed') {
      return build.result;
    }
    return build.status;
  }

}
